import { render } from "./StoreDesignDetail.vue?vue&type=template&id=0145b2ce&scoped=true"
import script from "./StoreDesignDetail.vue?vue&type=script&lang=js"
export * from "./StoreDesignDetail.vue?vue&type=script&lang=js"

import "./StoreDesignDetail.vue?vue&type=style&index=0&id=0145b2ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0145b2ce"]])

export default __exports__